export default __webpack_public_path__ + "static/media/seguranca2.6b6402ed.png";